import { type FC } from "react";
import { Button, Colors, Fonts } from "@snapchat/snap-design-system";
import styled from "@emotion/styled";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import { ContainerWithCamkitIcon } from "../../common/containers/onboarding/ContainerWithCamkitIcon";
import { type RouteParams, AbsoluteRoute } from "../../../core/routes";
import { CenteredSpinner } from "../components/CenteredSpinner";
import { EnableAppButton } from "../components/EnableAppButton";

export const EmptyAppContainer: FC = () => {
    const { orgId } = useParams<RouteParams[AbsoluteRoute.ORG_APPS]>();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(generatePath(AbsoluteRoute.ORG_APPS_CREATE, { orgId: orgId ?? "" }));
    };

    return orgId ? (
        <ContainerWithCamkitIcon>
            <Title>No app set up yet.</Title>
            <Body>
                Please select or create a web or mobile app to use Camera Kit for. Alternatively, invite team members to
                set up apps.
            </Body>
            <ButtonContainer>
                <EnableAppButton hasApps={false} organizationId={orgId} onClick={handleClick} isElevated>
                    Enable App
                </EnableAppButton>
                <Button type="link" target="_blank" href={`https://business.snapchat.com/${orgId}/settings/members`}>
                    Invite Team Members
                </Button>
            </ButtonContainer>
        </ContainerWithCamkitIcon>
    ) : (
        <CenteredSpinner />
    );
};

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h2`
    ${Fonts.Heading.H500};
    margin-bottom: 0;
`;

const Body = styled.p`
    ${Fonts.Paragraph.P200};
    max-width: 500px;
    color: ${Colors.Black.V50};
    text-align: center;
`;
